module.exports = __webpack_public_path__ + "static/media/error.03316029.png";